import React from 'react';
import styles from './text_block.css';


export default function TextBlock({ text }) {
  return (
    <p className={ styles.textBlock } dangerouslySetInnerHTML={{__html: text}} />
  )
};
